import { render, staticRenderFns } from "./fetchModal.vue?vue&type=template&id=5ba09668&scoped=true&"
import script from "./fetchModal.vue?vue&type=script&lang=js&"
export * from "./fetchModal.vue?vue&type=script&lang=js&"
import style0 from "./fetchModal.vue?vue&type=style&index=0&id=5ba09668&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba09668",
  null
  
)

export default component.exports